import { Container, type Application } from 'pixi.js';

export const VIRTUAL_W = 480;
export const VIRTUAL_H = 270;

/**
 * Fixed 480×270 virtual stage, integer-upscaled and centered. Everything
 * in the game positions in virtual pixels; the letterbox is the app
 * background color.
 */
export class StageScaler {
  readonly root = new Container();
  scale = 1;
  offsetX = 0;
  offsetY = 0;

  private readonly app: Application;

  constructor(app: Application) {
    this.app = app;
    app.stage.addChild(this.root);
    this.layout();
    app.renderer.on('resize', () => this.layout());
    window.addEventListener('resize', () => this.layout());
  }

  layout(): void {
    const { width, height } = this.app.screen;
    this.scale = Math.max(1, Math.floor(Math.min(width / VIRTUAL_W, height / VIRTUAL_H)));
    this.offsetX = Math.round((width - VIRTUAL_W * this.scale) / 2);
    this.offsetY = Math.round((height - VIRTUAL_H * this.scale) / 2);
    this.root.scale.set(this.scale);
    this.root.position.set(this.offsetX, this.offsetY);
  }

  screenToVirtual(x: number, y: number): { x: number; y: number } {
    return {
      x: (x - this.offsetX) / this.scale,
      y: (y - this.offsetY) / this.scale,
    };
  }
}
